<template>
  <div class="complectation-element-manage flex flex-col">
    <div class="title flex justify-between items-center">
      <span>{{ $t("client.landscaping.title") }}</span>
      <button @click="$store.dispatch('clientMain/setManageElement', null)">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="body flex-1 overflow-x-hidden">
      <div class="manage-step">
        <div class="manage-step-title">
          {{ $t("main.select_type") }}
        </div>
        <div class="manage-step-body">
          <div
            class="landscaping__types-list grid"
            v-if="baseTypes"
          >
            <template
              v-for="(type, index) in baseTypes"
              :key="`type-landscaping-${index}`"
            >
              <div
                class="landscaping__types-item"
                v-if="isShow(type.slug)"
              >
                <div class="relative flex items-center">
                  <input
                    type="radio"
                    class="landscaping__types-radio"
                    name="landscaping_type"
                    :id="`type-radio-landscaping-${index}`"
                    :value="type.slug"
                    :checked="
                                          selectedBaseType &&
                                              selectedBaseType.slug == type.slug
                                      "
                    @click="
                                          $store.dispatch(
                                              'clientLandscaping/selectBaseType',
                                              type
                                          )
                                      "
                  />
                  <label
                    class="landscaping__types-label"
                    :for="`type-radio-landscaping-${index}`"
                  >
                    <span class="landscaping__types-icon"><span></span></span>
                    {{ type.title }}</label>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- выбор основного элемента -->
      <div
        class="manage-step"
        v-if="mainElementTypes"
      >
        <div class="manage-step-title">
          {{ mainElementTypes.name }}:
        </div>
        <div class="manage-step-body">
          <div
            class="element-list-types"
            v-if="
                            mainElementTypes.types &&
                                mainElementTypes.types.length
                        "
          >
            <div
              class="choose-element-type"
              v-for="(type, ndx) in mainElementTypes.types"
              :key="`element-type-${ndx}`"
            >
              <div class="choose-element-type-title">
                <button
                  class="flex justify-between items-center focus:outline-none w-full"
                  @click="
                                        showElementsByType(
                                            'mainElementTypes',
                                            type
                                        )
                                    "
                >
                  <span class="img-txt flex items-center">
                    <span class="img flex justify-between items-center"><img
                        :src="type.image"
                        alt=""
                      /></span>
                    <span class="txt ml-2">{{
                                            type.name
                                        }}</span>
                  </span>
                  <span
                    class="arrow-down"
                    :class="{
                                            rotate:
                                                type.showElements ||
                                                (selectedMainElement &&
                                                    selectedMainElement.type_id ==
                                                        type.type_id &&
                                                    type.showElements)
                                        }"
                    style="background-image: url('/images/icons/icon-right-arrow.svg')"
                  >
                  </span>
                </button>
              </div>

              <landscaping-sidebar-elements
                :id="
                                    `mainElementTypes_elements__root-${type.type_id}`
                                "
                v-if="
                                    (type.showElements &&
                                        type.elements.length > 0) ||
                                        (selectedMainElement &&
                                            selectedMainElement.type_id ==
                                                type.type_id &&
                                            type.showElements)
                                "
                :type="type"
                :selected="selectedMainElement"
                :typePosition="'mainElementTypes'"
                @select-element="(element) => selectMainElement(element)"
                @mountedElements="
                                    setLoadingObserver(
                                        'mainElementTypes',
                                        type.type_id
                                    )
                                "
              />
            </div>
          </div>
        </div>
      </div>

      <!-- выбор бордюра -->
      <div
        class="manage-step"
        v-if="borderElementTypes && selectedBaseType && (selectedBaseType.slug == 'paving' || selectedBaseType.slug == 'grass' || selectedBaseType.slug == 'pour')"
      >
        <div class="manage-step-title">
          {{ borderElementTypes.name }}:
        </div>
        <div class="manage-step-body">
          <div
            class="element-list-types"
            v-if="
                            borderElementTypes.types &&
                                borderElementTypes.types.length
                        "
          >
            <div
              class="choose-element-type"
              v-for="(type, ndx) in borderElementTypes.types"
              :key="`element-type-${ndx}`"
            >
              <div class="choose-element-type-title">
                <button
                  class="flex justify-between items-center focus:outline-none w-full"
                  @click="
                                        showElementsByType(
                                            'borderElementTypes',
                                            type
                                        )
                                    "
                >
                  <span class="img-txt flex items-center">
                    <span class="img flex justify-between items-center"><img
                        :src="type.image"
                        alt=""
                      /></span>
                    <span class="txt ml-2">{{
                                            type.name
                                        }}</span>
                  </span>
                  <span
                    class="arrow-down"
                    :class="{
                                            rotate:
                                                type.showElements ||
                                                (selectedBorderElement &&
                                                    selectedBorderElement.type_id ==
                                                        type.type_id &&
                                                    type.showElements)
                                        }"
                    style="background-image: url('/images/icons/icon-right-arrow.svg')"
                  >
                  </span>
                </button>
              </div>
              <landscaping-sidebar-elements
                :id="
                                    `borderElementTypes_elements__root-${type.type_id}`
                                "
                v-if="
                                    (type.showElements &&
                                        type.elements.length > 0) ||
                                        (selectedBorderElement &&
                                            selectedBorderElement.type_id ==
                                                type.type_id &&
                                            type.showElements)
                                "
                :type="type"
                :selected="selectedBorderElement"
                :typePosition="'borderElementTypes'"
                @select-element="element=>selectBorderElement(element)"
                @mountedElements="
                                    setLoadingObserver(
                                        'borderElementTypes',
                                        type.type_id
                                    )
                                "
              />
            </div>
          </div>
        </div>
      </div>

      <!-- выбор облицовки -->
      <div
        class="manage-step"
        v-if="
                    selectedMainElement &&
                        selectedBaseType &&
                        (selectedBaseType.slug == 'plate-fill' ||
                            selectedBaseType.slug == 'stripe')
                "
      >
        <div class="manage-step-title">{{ $t("main.facing") }}:</div>

        <!-- выбор облицовки для верха -->
        <div
          class=""
          v-if="facingTopTypes && facingTopTypes.types"
        >
          <div class="text-lg font-bold">Верх:</div>
          <div class="manage-step-body">
            <div
              class="element-list-types"
              v-if="
                                facingTopTypes.types &&
                                    facingTopTypes.types.length
                            "
            >
              <div
                class="choose-element-type"
                v-for="(type, ndx) in facingTopTypes.types"
                :key="`element-facing-top-type-${ndx}`"
              >
                <div
                  class="choose-element-type-title"
                  v-if="type.elements.length"
                >
                  <button
                    class="flex justify-between items-center focus:outline-none w-full"
                    @click="
                                            facingTopTypes.types[
                                                ndx
                                            ].showElements = !facingTopTypes
                                                .types[ndx].showElements
                                        "
                  >
                    <span class="img-txt flex items-center">
                      <span class="img flex justify-between items-center"><img
                          :src="type.image"
                          alt=""
                        /></span>
                      <span class="txt ml-2">{{
                                                type.name
                                            }}</span>
                    </span>
                    <span
                      class="arrow"
                      :class="{
                                                down:
                                                    facingTopTypes.types[ndx]
                                                        .showElements ||
                                                    (selectedFacingElement.top &&
                                                        selectedFacingElement
                                                            .top.type_id ==
                                                            type.type_id)
                                            }"
                    >
                      <img
                        class="object-cover"
                        src="/images/icons/icon-right-arrow.svg"
                        alt=""
                      />
                    </span>
                  </button>
                </div>
                <div
                  class="choose-element-type-list-elements flex flex-wrap items-start overflow-x-hidden"
                  v-if="
                                        (facingTopTypes.types[ndx]
                                            .showElements &&
                                            type.elements.length > 0) ||
                                            (selectedFacingElement.top &&
                                                selectedFacingElement.top
                                                    .type_id == type.type_id)
                                    "
                >
                  <button
                    @click="selectFacingElement(element, 'top')"
                    class="choose-element-type-list-element focus:outline-none"
                    :class="{
                                            selected:
                                                selectedFacingElement &&
                                                selectedFacingElement.top &&
                                                selectedFacingElement.top
                                                    .element_id ==
                                                    element.element_id
                                        }"
                    v-for="(element, endx) in type.elements"
                    :key="`facing-top-element-${endx}`"
                    :title="`Название: ${element.name}; Артикул: ${element.article}`"
                  >
                    <i
                      class="fas fa-check absolute top-2 right-2"
                      v-if="
                                                selectedFacingElement &&
                                                    selectedFacingElement.top &&
                                                    selectedFacingElement.top
                                                        .element_id ==
                                                        element.element_id
                                            "
                    ></i>
                    <div class="img">
                      <img
                        class="object-cover"
                        :src="element.image"
                        :alt="`Название: ${element.name}; Артикул: ${element.article}`"
                      />
                    </div>
                    <div
                      class="article w-full"
                      :title="element.article"
                    >
                      {{ $shortArticle(element.article) }}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- выбор облицовки для боковых граней -->
        <div
          class="mt-4"
          v-if="facingSideTypes && facingSideTypes.types"
        >
          <div class="text-lg font-bold">
            {{ $t("client.landscaping.side_face") }}
          </div>
          <div class="manage-step-body">
            <div
              class="element-list-types"
              v-if="
                                facingSideTypes.types &&
                                    facingSideTypes.types.length
                            "
            >
              <div
                class="choose-element-type"
                v-for="(type, ndx) in facingSideTypes.types"
                :key="`element-facing-side-type-${ndx}`"
              >
                <div
                  class="choose-element-type-title"
                  v-if="type.elements.length"
                >
                  <button
                    class="flex justify-between items-center focus:outline-none w-full"
                    @click="
                                            facingSideTypes.types[
                                                ndx
                                            ].showElements = !facingSideTypes
                                                .types[ndx].showElements
                                        "
                  >
                    <span class="img-txt flex items-center">
                      <span class="img flex justify-between items-center"><img
                          :src="type.image"
                          alt=""
                        /></span>
                      <span class="txt ml-2">{{
                                                type.name
                                            }}</span>
                    </span>
                    <span
                      class="arrow"
                      :class="{
                                                down:
                                                    facingSideTypes.types[ndx]
                                                        .showElements ||
                                                    (selectedFacingElement.side &&
                                                        selectedFacingElement
                                                            .side.type_id ==
                                                            type.type_id)
                                            }"
                    >
                      <img
                        class="object-cover"
                        src="/images/icons/icon-right-arrow.svg"
                        alt=""
                      />
                    </span>
                  </button>
                </div>
                <div
                  class="choose-element-type-list-elements flex flex-wrap items-start overflow-x-hidden"
                  v-if="
                                        (facingSideTypes.types[ndx]
                                            .showElements &&
                                            type.elements.length > 0) ||
                                            (selectedFacingElement.side &&
                                                selectedFacingElement.side
                                                    .type_id == type.type_id)
                                    "
                >
                  <button
                    @click="selectFacingElement(element, 'side')"
                    class="choose-element-type-list-element focus:outline-none"
                    :class="{
                                            selected:
                                                selectedFacingElement &&
                                                selectedFacingElement.side &&
                                                selectedFacingElement.side
                                                    .element_id ==
                                                    element.element_id
                                        }"
                    v-for="(element, endx) in type.elements"
                    :key="`facing-side-element-${endx}`"
                    :title="`Название: ${element.name}; Артикул: ${element.article}`"
                  >
                    <i
                      class="fas fa-check absolute top-2 right-2"
                      v-if="
                                                selectedFacingElement &&
                                                    selectedFacingElement.side &&
                                                    selectedFacingElement.side
                                                        .element_id ==
                                                        element.element_id
                                            "
                    ></i>
                    <div class="img">
                      <img
                        class="object-cover"
                        :src="element.image"
                        :alt="`Название: ${element.name}; Артикул: ${element.article}`"
                      />
                    </div>
                    <div
                      class="article w-full"
                      :title="element.article"
                    >
                      {{ $shortArticle(element.article) }}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="manage-step"
        v-if="
                    selectedMainElement &&
                        selectedBaseType &&
                        selectedBaseType.slug == 'stripe'
                "
      >
        <div class="manage-step-title">
          {{ $t("client.landscaping.select_type_fill") }}:
        </div>
        <div class="manage-step-body">
          <div
            class="landscaping__types-list grid"
            v-if="fillTypes"
          >
            <div
              class="landscaping__types-item relative flex items-center"
              v-for="(type, index) in fillTypes"
              :key="`type-landscaping-${index}`"
            >
              <input
                type="radio"
                class="landscaping__types-radio"
                name="landscaping_type_fill"
                :id="`fill-type-radio-landscaping-${index}`"
                :value="type.slug"
                :checked="
                                    selectedFillType &&
                                        selectedFillType.slug == type.slug
                                "
                @click="
                                    $store.dispatch(
                                        'clientLandscaping/selectFillType',
                                        type
                                    )
                                "
              />
              <label
                class="landscaping__types-label"
                :for="`fill-type-radio-landscaping-${index}`"
              >
                <span class="landscaping__types-icon"><span></span></span>
                {{ type.title }}</label>
              <Hint :textHint="type.hint" />
            </div>
          </div>
        </div>
      </div>

      <!-- выбор элемента заполнения -->
      <div
        class="manage-step"
        v-if="fillElementTypes && selectedBaseType && selectedBaseType.slug == 'stripe'"
      >
        <div class="text-lg font-bold">
          {{ fillElementTypes.name }}:
        </div>
        <div class="manage-step-body">
          <div
            class="element-list-types"
            v-if="
                            fillElementTypes.types &&
                                fillElementTypes.types.length
                        "
          >
            <div
              class="choose-element-type"
              v-for="(type, ndx) in fillElementTypes.types"
              :key="`element-type-${ndx}`"
            >
              <div class="choose-element-type-title">
                <button
                  class="flex justify-between items-center focus:outline-none w-full"
                  @click="
                                        showElementsByType(
                                            'fillElementTypes',
                                            type
                                        )
                                    "
                >
                  <span class="img-txt flex items-center">
                    <span class="img flex justify-between items-center"><img
                        :src="type.image"
                        alt=""
                      /></span>
                    <span class="txt ml-2">{{
                                            type.name
                                        }}</span>
                  </span>
                  <span
                    class="arrow-down"
                    :class="{
                                            rotate:
                                                type.showElements ||
                                                (selectedFillElement &&
                                                    selectedFillElement.type_id ==
                                                        type.type_id &&
                                                    type.showElements)
                                        }"
                    style="background-image: url('/images/icons/icon-right-arrow.svg')"
                  >
                  </span>
                </button>
              </div>
              <landscaping-sidebar-elements
                :id="
                                    `fillElementTypes_elements__root-${type.type_id}`
                                "
                v-if="
                                    (type.showElements &&
                                        type.elements.length > 0) ||
                                        (selectedFillElement &&
                                            selectedFillElement.type_id ==
                                                type.type_id &&
                                            type.showElements)
                                "
                :type="type"
                :selected="selectedFillElement"
                :typePosition="'fillElementTypes'"
                @select-element="element=>selectFillElement(element)"
                @mountedElements="
                                    setLoadingObserver(
                                        'fillElementTypes',
                                        type.type_id
                                    )
                                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LandscapingSidebarElements from "./LandscapingSidebar/LandscapingSidebarElements.vue";
export default {
  components: { LandscapingSidebarElements },
  name: "Landscaping",
  created() {
    if (this.selected) {
      this.$store.dispatch("clientLandscaping/setLandscaping", this.selected);
      this.$store.dispatch("clientLandscaping/fetchMainElementTypes");
      if (this.selected.mainElementType) {
        if (
          this.selected.mainElementType.slug == "plate-fill" ||
          this.selected.mainElementType.slug == "stripe"
        ) {
          this.$store.dispatch("clientLandscaping/fetchFacingTypes");
        }
        if (
          this.selected.mainElementType.slug == "paving" ||
          this.selected.mainElementType.slug == "pour" ||
          this.selected.mainElementType.slug == "grass"
        ) {
          this.$store.dispatch("clientLandscaping/fetchBorderTypes");
        }
      }

      if (
        (this.selected.mainElement &&
          this.selected.mainElementType &&
          this.selected.mainElementType.slug == "paving") ||
        this.selected.fillElement
      ) {
        this.$store.dispatch("clientLandscaping/fetchFillElementTypes");
      }
    }
  },

  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
    selected() {
      return this.$store.state.clientOrder.landscaping;
    },
    selectedMainElement() {
      if (this.selected) {
        return this.selected.mainElement;
      }
      return null;
    },
    selectedBaseType() {
      if (this.selected) {
        return this.selected.mainElementType;
      }
      return null;
    },
    selectedFillType() {
      if (this.selected) {
        return this.selected.fillType;
      }
      return null;
    },
    selectedFillElement() {
      if (this.selected) {
        return this.selected.fillElement;
      }
      return null;
    },
    selectedBorderElement() {
      if (this.selected) {
        return this.selected.borderElement;
      }
      return null;
    },
    selectedFacingElement() {
      const facingElement = {
        top: null,
        side: null,
      };
      if (this.selected && this.selected.facing_top) {
        facingElement.top = this.selected.facing_top;
      }
      if (this.selected && this.selected.facing_side) {
        facingElement.side = this.selected.facing_side;
      }
      return facingElement;
    },

    baseTypes() {
      return this.$store.state.clientLandscaping.baseTypes;
    },
    mainElementTypes() {
      return this.$store.state.clientLandscaping.mainElementTypes;
    },
    facingTopTypes() {
      return this.$store.state.clientLandscaping.facingTopTypes;
    },
    facingSideTypes() {
      return this.$store.state.clientLandscaping.facingSideTypes;
    },
    showFillTypes() {
      return this.$store.state.clientLandscaping.showFillTypes;
    },
    fillTypes() {
      return this.$store.state.clientLandscaping.fillTypes;
    },
    fillElementTypes() {
      return this.$store.state.clientLandscaping.fillElementTypes;
    },
    borderElementTypes() {
      return this.$store.state.clientLandscaping.borderElementTypes;
    },
  },

  methods: {
    selectMainElement(element) {
      if (
        this.selectedMainElement &&
        this.selectedMainElement.element_id == element.element_id
      ) {
        this.$store.dispatch("clientOrder/removeLandscaping", "mainElement");
      } else {
        this.$store.dispatch("clientLandscaping/selectMainElement", element);
      }
    },

    selectFillElement(element) {
      if (
        this.selectedFillElement &&
        this.selectedFillElement.element_id == element.element_id
      ) {
        this.$store.dispatch("clientOrder/removeLandscaping", "fillElement");
      } else {
        this.$store.dispatch("clientLandscaping/selectFillElement", element);
      }
    },

    selectBorderElement(element) {
      if (
        this.selectedBorderElement &&
        this.selectedBorderElement.element_id == element.element_id
      ) {
        this.$store.dispatch("clientOrder/removeLandscaping", "borderElement");
      } else {
        this.$store.dispatch("clientLandscaping/selectBorderElement", element);
      }
    },

    //selectedFacingElement

    selectFacingElement(element, place) {
      if (
        this.selectedFacingElement &&
        this.selectedFacingElement[place] &&
        this.selectedFacingElement[place].element_id == element.element_id
      ) {
        this.$store.dispatch(
          "clientOrder/removeLandscaping",
          `facing_${place}`
        );
      } else {
        this.$store.dispatch("clientLandscaping/selectFacingElement", {
          selectedFacingElement: element,
          facing: place,
        });
      }
    },

    async showElementsByType(typePosition, type) {
      if (type.showElements) {
        this.$store.dispatch("clientLandscaping/clearTypeElements", {
          typePosition,
          typeId: type.type_id,
        });
      } else {
        await this.$store.dispatch("clientLandscaping/getElementsByType", {
          typePosition,
          typeId: type.type_id,
        });
      }

      this.$store.dispatch("clientLandscaping/setTypeShowElements", {
        typePosition,
        typeId: type.type_id,
        show: !type.showElements,
      });
    },
    setLoadingObserver(typePosition, typeId) {
      const element = document.getElementById(
        `${typePosition}_elements__loader-${typeId}`
      );
      const rootElement = document.getElementById(
        `${typePosition}_elements__root-${typeId}`
      );

      if (rootElement && element) {
        const loadingObserver = new IntersectionObserver(
          async (entries) => {
            entries.forEach(async (entry) => {
              if (entry.isIntersecting) {
                await this.$store.dispatch(
                  "clientLandscaping/getElementsByType",
                  {
                    typePosition,
                    typeId,
                  }
                );
              }
            });
          },
          {
            root: rootElement,
            threshold: 0.5,
          }
        );
        loadingObserver.observe(element);
      }
    },
    isShow(code) {
      return (
        this.settings &&
        this.settings.landscapings_catalog &&
        this.settings.landscapings_catalog.some((el) => el.code === code)
      );
    },
  },
};
</script>
<style scoped>
.arrow-down {
  width: 10px;
  height: 10px;
  background-size: contain;
  background-repeat: no-repeat;
  transition: transform 0.3s ease;
  display: inline-block;
}
.arrow-down.rotate {
  transform: rotate(90deg);
}
.arrow {
  display: inline-block;
  transition: transform 0.3s ease;
  width: 10px;
  height: 10px;
}
.arrow.down {
  transform: rotate(90deg);
}
.arrow img {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 1000px) {
  .landscaping__types-list {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
